import styled from "styled-components";
import Title from "../../../common/Title";
import Division from "../../../common/Division";
import SkillBox from "../../../common/SkillBox";
import Content from "../../../common/Content";
import ec2 from "../../../../assets/img/new/aws-ec2.svg";
import s3 from "../../../../assets/img/new/aws-s3.svg";
import rds from "../../../../assets/img/new/aws-rds.svg";
import Accordion from "../../../common/Accordion";
import ListItem from "../../../common/ListItem";
import ProjectLink from "../../../common/ProjectLink";
import ProjectLinkBox from "../../../common/ProjectLinkBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub } from "@fortawesome/free-brands-svg-icons";

const Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export default function DemureBox() {
  return (
    <Box>
      <Title>가구 쇼핑몰, Demure</Title>
      <Division>팀 프로젝트</Division>
      <SkillBox
        skill={[
          { logo: "React", content: "리액트(React)", color: "61DAFB" },
          {
            logo: "TypeScript",
            content: "타입스크립트(TypeScript)",
            color: "3178C6",
            division: true,
          },
          { logo: "NestJs", content: "NestJs", color: "E0234E" },
          { logo: "amazonec2", content: "AWS EC2", color: "FF9900", img: ec2 },
          { logo: "amazonrds", content: "AWS RDS", color: "527FFF", img: rds },
          {
            logo: "amazons3",
            content: "AWS S3",
            color: "569A31",
            division: true,
            img: s3,
          },
          { logo: "postgresql", content: "PostgreSQL", color: "4169E1" },
        ]}
      />
      <Content>
        <Accordion title="개요" open={true}>
          Demure는 이케아(IKEA) 데이터를 활용한 가구 쇼핑몰 입니다. React와
          NestJS를 활용해 사이트를 구현했습니다.
        </Accordion>
        <Accordion title="주요 기능 및 역할" open={true}>
          <ListItem>
            NodeMailer를 이용해 이메일 인증 기능을 구현했습니다.
          </ListItem>
          <ListItem>장바구니 및 배송지 관리 기능을 제공합니다.</ListItem>
          <ListItem>쿠폰을 발급하고 사용할 수 있는 기능을 제공합니다.</ListItem>
          <ListItem>상품 검색과 색상별 검색 기능을 지원합니다.</ListItem>
          <ListItem>
            카카오 소셜 로그인을 통해 간편하게 로그인할 수 있습니다.
          </ListItem>
          <ListItem>Redux Toolkit을 활용해 전역 상태를 관리합니다.</ListItem>
          <ListItem>AWS EC2 환경에서 애플리케이션을 배포했습니다.</ListItem>
        </Accordion>
        <ProjectLinkBox>
          {/* <ProjectLink href="https://github.com/KDT9Demure" title="Home">
            <FontAwesomeIcon icon={faHouse} />
          </ProjectLink> */}
          <ProjectLink href="https://github.com/KDT9Demure" title="Github">
            <FontAwesomeIcon icon={faGithub} />
          </ProjectLink>
        </ProjectLinkBox>
      </Content>
    </Box>
  );
}
